export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('default');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${formattedDate} - ${hours}:${minutes}`;
}

export function calculateRate(total, number) {
  if (parseInt(total) === 0 || parseInt(number) === 0) return 0
  const rate = Math.round((parseFloat(number) / parseFloat(total)) * 100)
  return rate < 1 ? '< 1' : rate
}

export function formatPercent(value, total) {
  if (total === 0 || !total || !value) return '0%'
  const percentage = ((value / total) * 100)
  if (percentage > 0 && percentage < 1) return '< 1%'
  return `${Math.round(percentage)}%`
}

export function formatFinancial(value, showDecimals = false) {
  const number = parseFloat(value)
  if (isNaN(number)) return '£0' + (showDecimals ? '.00' : '')
  const pounds = number / 100
  const options = showDecimals
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : { maximumFractionDigits: 0 }
  return `£${pounds.toLocaleString(undefined, options)}`
}
